export const CATEGORIES = [
  '油錢', '保險', '車錢', '驗車',
  '耗材更換', '大保養', '小保養', '裝備',
] as const

export type Category = typeof CATEGORIES[number]

export const FUEL_GRADES = ['92', '95', '98'] as const
export type FuelGrade = typeof FUEL_GRADES[number]

export interface RecordForm {
  date: string          // 'YYYY-MM-DD'
  category: Category
  amount: string        // 字串方便輸入
  odometer_km: string
  description: string
  note: string
  fuel_grade: FuelGrade
  liters: string        // 手動公升數，空 = 估算
  is_full_tank: boolean
}

export function defaultForm(lastCategory: Category, lastOdometer: number): RecordForm {
  return {
    date: new Date().toISOString().slice(0, 10),
    category: lastCategory,
    amount: '',
    odometer_km: lastOdometer > 0 ? String(lastOdometer) : '',
    description: '',
    note: '',
    fuel_grade: '95',
    liters: '',
    is_full_tank: true,
  }
}
